/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @fileoverview This file contains functions related to Date, Time and Delay.
 */

/**
 * Function to return promise to be resolved after provided delay.
 * @param {number} delay - Waiting time for the promise to get resolved.
 * @return {Promise}
 */
export const waitFor = delay => {
    return new Promise(resolve => { setTimeout(resolve, delay); });
};
